var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length)?_c('div',{staticClass:"error_messages"},_vm._l((_vm.errors),function(error){return _c('div',{key:error,staticClass:"error_message"},[_vm._v(_vm._s(_vm.$t(error)))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }